var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarSelectedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9507 6.63306L7.13303 4.54928C6.31719 4.40543 5.5392 4.95018 5.39535 5.76602L3.48522 16.5989C3.34136 17.4148 3.88612 18.1927 4.70196 18.3366L16.5197 20.4204C17.3355 20.5642 18.1135 20.0195 18.2573 19.2036L20.1675 8.37075C20.3113 7.55491 19.7666 6.77692 18.9507 6.63306ZM7.3935 3.07207C5.76182 2.78436 4.20585 3.87387 3.91814 5.50555L2.00801 16.3384C1.7203 17.9701 2.8098 19.5261 4.44149 19.8138L16.2592 21.8976C17.8909 22.1853 19.4468 21.0958 19.7345 19.4641L21.6447 8.63122C21.9324 6.99954 20.8429 5.44356 19.2112 5.15585L7.3935 3.07207Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55565 7.64882L20.3126 10.4272L18.4024 21.2601L2.64552 18.4817L4.55565 7.64882Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53677 2.43456C9.63267 1.89067 10.1513 1.5275 10.6952 1.6234C11.2391 1.7193 11.6023 2.23796 11.5064 2.78186L10.9854 5.73628C10.8895 6.28018 10.3709 6.64334 9.82698 6.54744C9.28309 6.45154 8.91992 5.93288 9.01582 5.38898L9.53677 2.43456Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4456 3.47645C15.5415 2.93256 16.0602 2.56939 16.6041 2.66529C17.148 2.76119 17.5111 3.27985 17.4152 3.82375L16.8943 6.77817C16.7984 7.32206 16.2797 7.68523 15.7358 7.58933C15.1919 7.49343 14.8288 6.97477 14.9247 6.43087L15.4456 3.47645Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarSelectedIcon);
export default __webpack_public_path__ + "static/media/CalendarSelectedIcon.743ba6efbfdf22f7e0d01d21c831ef70.svg";
export { ForwardRef as ReactComponent };